// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconAlphaN = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M9.487 17H7.779V6.948H9.99l3.29 5.726c.33.585.742 1.355 1.056 1.942l.092.172h.028c-.014-.616-.028-1.75-.028-2.73v-5.11h1.708V17H13.98l-3.234-5.53a60 60 0 01-.816-1.459c-.184-.339-.34-.625-.458-.823h-.028c0 .2.007.51.016.859.012.455.026.98.026 1.423z" />,
    <path
      fillRule="evenodd"
      d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2M4 12a8 8 0 1116 0 8 8 0 01-16 0"
    />
  );
export default SvgIconAlphaN;
